export const customSelectStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    padding: "10px 20px",
    textAlign: "left",
    width: "100%",
    fontSize: "0.8em",
    color: "#000",
    backgroundColor: "none",
    cursor: "pointer"
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    color: "#fff"
  }),
  container: (provided: any) => ({
    ...provided,
      border: "1px solid #fff",
      width: "100%",
      height: "50px",
      position: "relative"

  }),
  control: (provided: any) => ({
    ...provided,
    // none of react-select's styles are passed to <Control />
    width: "100%",
    height: "100%",
    margin: 0,
    backgroundColor: "none",
    position: "absolute",
    float: "none",
    borderRadius: "0",
    border: "none"
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    cursor: "pointer"
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    textAlign: "center",
    cursor: "pointer"
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#fff",
    fontWeight: "normal",
    textAlign: "left",
    paddingLeft: "12px",
    width: "100%",
    cursor: "pointer"
  }),
  menu: (provided: any) => ({
    ...provided,
    width: "100%",
    marginLeft: 0,
    marginTop: 0,
    border: 0,
    borderRadius: 0,
    backgroundColor: "#e8e8e8",
    overflowY: "scroll",
    cursor: "pointer"
  }),
  dropdownIndicator: (provided:any) => ({
    ...provided,
    position: "absolute",
    right: "0"

  }),
  singleValue: (provided:any) => ({
    ...provided,
    color: "#fff",
    fontWeight: "normal",
    textAlign: "left",
    paddingLeft: "12px",
    width: "100%",
    cursor: "pointer"
  })
}
